import { useMemo } from 'react';
const canUseDOM = typeof window !== 'undefined' && typeof window.document !== 'undefined';
const MODAL_WINDOW_PORTAL_ROOT_ID = 'modal-window-portal-root';
export function usePortalCreatorRoot(portalRoot) {
    const portal = useMemo(() => {
        if (portalRoot !== undefined) {
            return portalRoot;
        }
        if (!canUseDOM) {
            return null;
        }
        let root = document.getElementById(MODAL_WINDOW_PORTAL_ROOT_ID);
        if (!root) {
            root = document.createElement('div');
            root.id = MODAL_WINDOW_PORTAL_ROOT_ID;
            root.style.width = '0px';
            root.style.height = '0px';
            root.style.overflow = 'hidden';
            document.body.appendChild(root);
        }
        return root;
    }, [portalRoot]);
    return portal;
}
